import { ApplicationConfig, importProvidersFrom, isDevMode, inject, provideZoneChangeDetection } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { provideRouter, withDebugTracing, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { Globals } from './shared/models/globals';
import { CommonModule } from '@angular/common';
import { PermissionsService } from './auth/auth-guard.guard';
import { UserService } from './shared/services/user.service';
import { AuthInterceptor, authInterceptorProvider } from './auth/auth.interceptor';

// import ngx-translate and the http loader
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient} from '@angular/common/http';
import { ThemeService } from './shared/services/themes/theme.service';
import { StyleManagerService } from './shared/services/themes/style-manager.service';
import { provideServiceWorker } from '@angular/service-worker';

import {provideTranslateService, TranslateService} from "@ngx-translate/core";
import {provideTranslateHttpLoader} from "@ngx-translate/http-loader";

// AoT requires an exported function for factories
/* export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
} */


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withInMemoryScrolling({
      scrollPositionRestoration: "top",

    })
    ),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),

    Globals,
    CommonModule,
    ThemeService,
    StyleManagerService,
    UserService,
    //importProvidersFrom(HttpClientModule),
    authInterceptorProvider,
        provideHttpClient(),
    provideTranslateService({
      lang: 'en',
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      })
    }),
/*     importProvidersFrom(TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient],
        },
    })), */
    PermissionsService, provideServiceWorker('ngsw-worker.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000'
    })]
};
